import { ratioToPercent, round2 } from '../../../lib/format';

export function LineupTooltip({ data }) {
  const lineupStrings = [];
  const value = data.isPercent
    ? ratioToPercent(round2(data.value))
    : round2(data.value);
  let tooltipText = `
    <div style="text-align: center">
      <strong>${data.chartName}</strong>: ${value}
    </div>
    `;
  for (const player of data.lineup.players) {
    lineupStrings.push(`${player.jersey} ${player.name}`);
  }
  for (const lineupString of lineupStrings) {
    tooltipText += `<div>${lineupString}</div>`;
  }
  return `
    <div class="chart-tooltip">
      ${tooltipText}
    </div>`;
}
